(function () {
  "use strict";

  const STORAGE_KEY_PREFIX = "pd_license_image_";
  const STORAGE_KEY_FILENAME_PREFIX = "pd_license_filename_";

  function initLicenseGenerator() {
    const sections = document.querySelectorAll(
      ".pd-license-generator[data-section-id]",
    );

    sections.forEach((section) => {
      const sectionId = section.getAttribute("data-section-id");

      const currentStep = section.getAttribute("data-current-step");

      const fileInput = /** @type {HTMLInputElement} */ (
        section.querySelector(`#pd-license-upload-${sectionId}`)
      );
      const preview = /** @type {HTMLElement} */ (
        section.querySelector(`#pd-license-preview-${sectionId}`)
      );
      const previewImage = /** @type {HTMLImageElement} */ (
        section.querySelector(`#pd-license-preview-image-${sectionId}`)
      );
      const previewFilename = section.querySelector(
        `#pd-license-preview-filename-${sectionId}`,
      );
      const removeBtn = section.querySelector(
        `.pd-license-generator__remove-image[data-section-id="${sectionId}"]`,
      );
      const nextBtn = /** @type {HTMLButtonElement} */ (
        section.querySelector(`#pd-license-next-${sectionId}`)
      );
      const validation = /** @type {HTMLElement} */ (
        section.querySelector(`#pd-license-validation-${sectionId}`)
      );
      const uploadLabel = /** @type {HTMLLabelElement} */ (
        section.querySelector(`#pd-license-upload-label-${sectionId}`)
      );
      const validationModal = section.querySelector(
        `#pd-license-validation-modal-${sectionId}`,
      );
      const validationModalImage = section.querySelector(
        `#pd-license-validation-image-${sectionId}`,
      );
      const validationModalClose = section.querySelector(
        `.pd-license-generator__validation-modal-close[data-close-modal="pd-license-validation-modal-${sectionId}"]`,
      );

      if (!fileInput || !preview || !previewImage || !nextBtn) return;

      // Add drag and drop functionality to the upload label
      let dragCounter = 0;

      uploadLabel.addEventListener("dragenter", function (e) {
        e.preventDefault();
        e.stopPropagation();
        dragCounter++;
        if (dragCounter === 1) {
          this.classList.add("pd-license-generator__upload-label--dragover");
        }
      });

      uploadLabel.addEventListener("dragover", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });

      uploadLabel.addEventListener("dragleave", function (e) {
        e.preventDefault();
        e.stopPropagation();
        dragCounter--;
        if (dragCounter === 0) {
          this.classList.remove("pd-license-generator__upload-label--dragover");
        }
      });

      uploadLabel.addEventListener("drop", function (e) {
        e.preventDefault();
        e.stopPropagation();
        dragCounter = 0;
        this.classList.remove("pd-license-generator__upload-label--dragover");

        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
          const file = files[0];
          if (file && file.type.startsWith("image/")) {
            // Process the dropped file
            processFile(
              file,
              sectionId,
              fileInput,
              preview,
              previewImage,
              previewFilename,
              nextBtn,
              validation,
              uploadLabel,
            );
          } else {
            showValidation(sectionId, validation);
            nextBtn.disabled = true;
          }
        }
      });

      // Load saved image from sessionStorage
      const savedImage = sessionStorage.getItem(
        `${STORAGE_KEY_PREFIX}${sectionId}`,
      );
      const savedFilename = sessionStorage.getItem(
        `${STORAGE_KEY_FILENAME_PREFIX}${sectionId}`,
      );
      if (savedImage) {
        previewImage.src = savedImage;
        if (previewFilename && savedFilename) {
          previewFilename.textContent = savedFilename;
        }
        preview.style.display = "flex";
        if (uploadLabel) {
          uploadLabel.style.display = "none";
        }
        nextBtn.disabled = false;
      }

      // File input change handler
      fileInput.addEventListener("change", function (e) {
        const target = /** @type {HTMLInputElement} */ (e.target);
        const file = target.files && target.files[0];
        if (!file) {
          return;
        }

        if (
          (file.type.startsWith("image/") && file.type.endsWith("jpg")) ||
          file.type.endsWith("jpeg") ||
          file.type.endsWith("png") ||
          file.type.endsWith("gif")
        ) {
          processFile(
            file,
            sectionId,
            fileInput,
            preview,
            previewImage,
            previewFilename,
            nextBtn,
            validation,
            uploadLabel,
          );
        } else {
          showValidation(sectionId, validation);
          nextBtn.disabled = true;
        }
      });

      // Remove image handler
      if (removeBtn) {
        removeBtn.addEventListener("click", function () {
          fileInput.value = "";
          preview.style.display = "none";
          if (uploadLabel) {
            uploadLabel.style.display = "flex";
          }
          nextBtn.disabled = true;
          if (validation) {
            validation.style.display = "none";
          }
          if (previewFilename) {
            previewFilename.textContent = "";
          }

          // Remove from sessionStorage
          sessionStorage.removeItem(`${STORAGE_KEY_PREFIX}${sectionId}`);
          sessionStorage.removeItem(
            `${STORAGE_KEY_FILENAME_PREFIX}${sectionId}`,
          );
        });
      }

      // Next button click handler with validation
      nextBtn.addEventListener("click", function (e) {
        // Check if button is disabled
        if (nextBtn.disabled) {
          e.preventDefault();
          e.stopPropagation();
          showValidation(sectionId, validation);
          return false;
        }

        // Double-check if image exists (prevent cheating)
        const hasImage =
          previewImage.src &&
          previewImage.src !== window.location.href &&
          previewImage.src !== "" &&
          preview.style.display !== "none";

        if (!hasImage) {
          e.preventDefault();
          e.stopPropagation();
          showValidation(sectionId, validation);
          nextBtn.disabled = true;
          return false;
        }

        // Image is valid, open validation modal
        if (validationModal && validationModalImage) {
          // Set the image in the modal
          const modalImg = /** @type {HTMLImageElement} */ (
            validationModalImage
          );
          modalImg.src = previewImage.src;

          // Open the modal using the PD modal system
          const modalElement = document.getElementById(
            `pd-license-validation-modal-${sectionId}`,
          );
          if (modalElement) {
            modalElement.classList.add("active");
            document.documentElement.classList.add("opening-modal");

            // Handle auto-close
            const autoClose =
              validationModal.getAttribute("data-auto-close") === "true";
            const autoCloseDelay = parseInt(
              validationModal.getAttribute("data-auto-close-delay") || "3000",
              10,
            );

            if (autoClose) {
              // Wait for animation to complete (checkmark animation duration)
              const animationDuration = 2000; // 2 seconds for checkmark animation
              const closeDelay = Math.max(autoCloseDelay, animationDuration);

              setTimeout(() => {
                if (modalElement.classList.contains("active")) {
                  modalElement.classList.remove("active");
                  document.documentElement.classList.remove("opening-modal");

                  // Switch to step 2 with a slight delay for smoother transition
                  if (currentStep === "1") {
                    setTimeout(() => {
                      section.setAttribute("data-current-step", "2");
                      switchToStep2(sectionId);
                    }, 100);
                  }
                }
              }, closeDelay);
            }
          }
        }

        // You can add navigation logic here for multi-step flow
        // For example: window.location.href = '/next-step';
      });
    });
  }

  function processFile(
    file,
    sectionId,
    fileInput,
    preview,
    previewImage,
    previewFilename,
    nextBtn,
    validation,
    uploadLabel,
  ) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const imageDataUrl = /** @type {string} */ (event.target.result);
      previewImage.src = imageDataUrl;

      // Display file name
      if (previewFilename) {
        previewFilename.textContent = file.name;
      }

      preview.style.display = "flex";
      if (uploadLabel) {
        uploadLabel.style.display = "none";
      }
      nextBtn.disabled = false;
      if (validation) {
        validation.style.display = "none";
      }

      // Save to sessionStorage
      sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${sectionId}`, imageDataUrl);
      sessionStorage.setItem(
        `${STORAGE_KEY_FILENAME_PREFIX}${sectionId}`,
        file.name,
      );
    };
    reader.readAsDataURL(file);
  }

  function showValidation(sectionId, validationElement) {
    if (validationElement) {
      validationElement.style.display = "flex";
      validationElement.classList.add("active");
      // Scroll to validation message
      validationElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }

  function switchToStep2(sectionId) {
    const section = document.querySelector(
      `.pd-license-generator[data-section-id="${sectionId}"]`,
    );
    if (!section) return;

    const step2Container = section.querySelector(
      ".pd-license-generator__step-2-wrapper",
    );
    if (step2Container) {
      // Initialize step 2 functionality
      initStep2(sectionId);
    }
  }

  function initStep2(sectionId) {
    const section = document.querySelector(
      `.pd-license-generator__step-2-wrapper[data-section-id="${sectionId}"]`,
    );

    if (!section) return;

    const nameInput = /** @type {HTMLInputElement} */ (
      section.querySelector(`#pd-license-driver-name-${sectionId}`)
    );
    const characterGrid = section.querySelector(
      `#pd-license-character-grid-${sectionId}`,
    );
    const checkoutBtn = /** @type {HTMLButtonElement} */ (
      section.querySelector(`#pd-license-checkout-${sectionId}`)
    );
    const namePreview = /** @type {HTMLElement} */ (
      section.querySelector(`#pd-license-name-preview-${sectionId}`)
    );
    const characterPreview = /** @type {HTMLElement} */ (
      section.querySelector(`#pd-license-character-preview-${sectionId}`)
    );
    const step2Validation = /** @type {HTMLElement} */ (
      section.querySelector(`#pd-license-step2-validation-${sectionId}`)
    );
    const step2NameRequiredValidation = /** @type {HTMLElement} */ (
      section.querySelector(
        `#pd-license-step2-name-required-validation-${sectionId}`,
      )
    );

    let selectedCharacter = null;

    // Name input handler with real-time validation
    if (nameInput && namePreview) {
      const nameLengthLimit = nameInput.getAttribute("maxlength");
      nameInput.addEventListener("input", function (e) {
        if (nameLengthLimit) {
          const _nameLengthLimit = parseInt(nameLengthLimit);
          if (this.value.length >= _nameLengthLimit) {
            return;
          }
        }

        const name = this.value.trim();

        // Update license preview in real-time
        namePreview.textContent = name || "";

        // Validate against blocked words using regex (case-insensitive)
        const blockedWordsStr = this.getAttribute("data-blocked-words") || "";
        const blockedWords = blockedWordsStr
          .split(",")
          .map((word) => word.trim())
          .filter((word) => word.length > 0);

        let containsBlockedWord = false;
        if (blockedWords.length > 0 && name.length > 0) {
          // Create case-insensitive regex patterns for each blocked word
          const blockedPatterns = blockedWords.map((word) => {
            // Escape special regex characters and create case-insensitive match
            const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            return new RegExp(`\\b${escaped}\\b`, "i");
          });

          // Check if name contains any blocked word
          containsBlockedWord = blockedPatterns.some((pattern) =>
            pattern.test(name),
          );
        }

        // Show/hide validation message
        if (containsBlockedWord && step2Validation) {
          /** @type {HTMLElement} */ (step2Validation).style.display = "flex";
          checkoutBtn.disabled = true;
        } else if (step2Validation) {
          /** @type {HTMLElement} */ (step2Validation).style.display = "none";
        }

        checkFormValidity();
      });
    }

    // Character selection handler
    if (characterGrid) {
      characterGrid.addEventListener("click", function (e) {
        const target = /** @type {HTMLElement} */ (e.target);
        const characterOption = target.closest(
          ".pd-license-generator__character-option",
        );

        if (characterOption) {
          // Remove previous selection
          characterGrid
            .querySelectorAll(".pd-license-generator__character-option")
            .forEach((option) => {
              option.classList.remove(
                "pd-license-generator__character-option--selected",
              );
            });

          // Select new character
          characterOption.classList.add(
            "pd-license-generator__character-option--selected",
          );
          selectedCharacter = {
            id: characterOption.getAttribute("data-character-id"),
            image: characterOption.getAttribute("data-character-image"),
            name: characterOption.getAttribute("data-character-name"),
          };

          // Update preview
          if (characterPreview) {
            characterPreview.innerHTML = `
              <img
                src="${selectedCharacter.image}"
                alt="${selectedCharacter.name}"
                width="200"
                height="200"
                class="pd-license-generator__character-image"
              >
            `;
          }

          checkFormValidity();
        }
      });
    }

    // Checkout button handler
    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", function () {
        const name = nameInput?.value.trim();
        if (!name) {
          if (step2NameRequiredValidation) {
            /** @type {HTMLElement} */ (
              step2NameRequiredValidation
            ).style.display = "flex";
          }
          return;
        }

        let _selectedCharacter = selectedCharacter;

        if (!selectedCharacter) {
          // Get the first character option
          const firstCharacterOption = characterGrid.querySelector(
            ".pd-license-generator__character-option:first-of-type",
          );
          if (firstCharacterOption) {
            _selectedCharacter = {
              image: firstCharacterOption.getAttribute("data-character-image"),
              name: firstCharacterOption.getAttribute("data-character-name"),
            };
          }
        }

        // Prepare custom data for checkout
        const customData = {
          driver_name: name,
          issued_date: new Date().toISOString().split("T")[0],
          character_name: _selectedCharacter.name,
          character_avatar: _selectedCharacter.image,
        };

        const customDataToBase64 = btoa(JSON.stringify(customData));
        const productVariantId = checkoutBtn.getAttribute(
          "data-product-variant-id",
        );
        if (!productVariantId) {
          console.error("Product variant ID is not set");
          return;
        }

        const isDisabled = checkFormValidity();
        if (isDisabled) {
          return;
        }

        sessionStorage.removeItem(`${STORAGE_KEY_PREFIX}${sectionId}`);
        const checkoutLink = `${window.location.origin}/cart/${productVariantId}:1?properties=${customDataToBase64}&note=${customDataToBase64}`;
        window.location.href = checkoutLink;
      });
    }

    function checkFormValidity() {
      const name = nameInput?.value.trim();
      const hasName = name && name.length > 0;
      const hasBlockedWord =
        step2Validation &&
        /** @type {HTMLElement} */ (step2Validation).style.display !== "none";

      const isDisabled = !hasName || hasBlockedWord;
      if (checkoutBtn) {
        checkoutBtn.disabled = isDisabled;
      }

      return isDisabled;
    }
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLicenseGenerator);
  } else {
    initLicenseGenerator();
  }
})();
